import React from 'react';
import {
    HashRouter,
  } from "react-router-dom";

import Header from './js/Header';
import SideNavbar from './js/SideNav';
import PortNavbar from './js/PortNav'
import Sidebar from './js/Sidebar';
import Container from './js/Container';
import Footer from './js/Footer';

import './App.scss';


class Main extends React.Component {
    render(){
        return (
            <HashRouter>
            <div>
            <Header />
            <div className="custom_bodycontainer">
                <SideNavbar />
                <PortNavbar />
                <Container />
            <Sidebar />
            </div>
            <Footer />
            </div>
            </HashRouter>
        );
    }
}



export default Main;
